import { Row } from 'antd';
import styled from 'styled-components';

const ContentModalVerification = styled(Row)``;

const TextError = styled.p`
  font-size: 15px;
  margin-top: 2px !important;

  margin-bottom: 10px !important;
`;

const ContentDescription = styled(Row)`
  margin-bottom: 20px !important;
`;

export { ContentModalVerification, TextError, ContentDescription };
